import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SNItemTableComponent } from './components/snitem-table/snitem-table.component';
import { SNItemTableControlComponent } from './components/snitem-table-control/snitem-table-control.component';
import { MatTableModule } from '@angular/material/table';
import { SNItemTableRowComponent } from './components/snitem-table-row/snitem-table-row.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { SNItemTableRowIconsComponent } from './snitem-table-row-icons/snitem-table-row-icons.component';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  declarations: [SNItemTableComponent, SNItemTableControlComponent, SNItemTableRowComponent, SNItemTableRowIconsComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatDatepickerModule,
  ],
  exports: [
    SNItemTableComponent,
    SNItemTableControlComponent,
    SNItemTableRowIconsComponent
  ]
})
export class SNItemTableModule { }
